import roi_icon from "../../assets/dashboard-roi.svg"
import individual from "../../assets/individual-effectiveness.svg"
import team from "../../assets/team-effectiveness.svg"
import filled_star from "../../assets/teams-filled-star.svg";
import empty_star from "../../assets/teams-empty-star.svg";
import {useEffect, useState} from "react";
import recommended from "../../assets/recommended-thumb.svg";
import Slider from "../Slider";
import info from "../../assets/info-icon.png"
import tick from "../../assets/dashboard-roi-tick.svg"
import dashboard_api from "../../api/protected/dashboard"
import {useNavigate} from "react-router-dom";


const ROICard = () => {

    const starMap = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const [roiData, setRoiData] = useState(null)
    const [showBenchmark, setShowBenchmark] = useState(true)
    const navigate = useNavigate()

    const [showTitleHover, setShowTitleHover] = useState(false)
    const [showTeamCoachRatingsHover, setShowTeamCoachRatingsHover] = useState(false)
    const [showTeamEffectivenessHover, setShowTeamEffectivenessHover] = useState(false)
    const [showIndividualHover, setShowIndividualHover] = useState(false)
    const [showRecommendedHover, setShowRecommendedHover] = useState(false)
    const [showPlatformHover, setShowPlatformHover] = useState(false)
    const [showPerformanceHover, setShowPerformanceHover] = useState(false)

    useEffect(() => {
        getCoachROI()
    }, []);

    const getCoachROI = () => {
        let response = dashboard_api.getCoachROI();
        response.then(response => {
            setRoiData(response.data)
        }).catch(err => console.log(err))
    }

    return (
        <div className="dashboard-roi-card-container" style={{display: roiData?.display ? "" : "none"}}>
            <div className="dashboard-roi-top-row">
                <div className="dashboard-roi-title bold">
                    TEAM COACHING PERFORMANCE SUMMARY
                    <img src={info} alt="Info"
                         onMouseOver={() => setShowTitleHover(true)}
                         onMouseLeave={() => setShowTitleHover(false)}
                    />
                </div>
                {showTitleHover ?
                    <div className="dashboard-roi-title-hover" style={{top: 40, left: 420}}>
                        <div className="dashboard-roi-title-hover-triangle-outer">
                            <div className="dashboard-roi-title-hover-triangle-inner"/>
                        </div>
                        <div className="dashboard-roi-title-hover-text regular">
                            This card displays an overview of performance for your Teams* over time (including any
                            co-coaches), your ratings and the PERILL Platform ratings. <br/><br/>
                            *at least two initial and end point responses per team are required to qualify
                        </div>
                    </div> : null
                }
                <div className="dashboard-roi-details-row">
                    <div className="dashboard-roi-details-main">
                        <div className="dashboard-roi-details-text regular">Responses included:</div>
                        <div className="dashboard-roi-details-responses-text regular">Total Teams:</div>
                        <div className="dashboard-roi-details-responses-text bold">{roiData?.team_count}</div>
                        <div className="dashboard-roi-details-responses-text regular">and Total Participants:</div>
                        <div className="dashboard-roi-details-responses-text bold">{roiData?.user_count}</div>
                    </div>
                    <div className="dashboard-roi-details-report-button bold" onClick={() => navigate("/roireport")}>
                        <div className="button-text">SEE DETAILS</div>
                        <img src={roi_icon} alt="See details"/>
                    </div>
                </div>
            </div>
            <div className="dashboard-roi-main-container">
                <div className="dashboard-roi-main-left">
                    <div className="dashboard-roi-title bold margined">
                        Team Coach Ratings
                        <img src={info} alt="Info"
                             onMouseOver={() => setShowTeamCoachRatingsHover(true)}
                             onMouseLeave={() => setShowTeamCoachRatingsHover(false)}
                        />
                    </div>
                    {showTeamCoachRatingsHover ?
                        <div className="dashboard-roi-title-hover" style={{top: 60, left: 177}}>
                            <div className="dashboard-roi-title-hover-triangle-outer">
                                <div className="dashboard-roi-title-hover-triangle-inner"/>
                            </div>
                            <div className="dashboard-roi-title-hover-text regular">
                                This section looks at the collated ratings given by all your responding team
                                participants on how they feel the Team Coach has impacted performance.
                            </div>
                        </div> : null
                    }
                    <div className="edit-team-feedback-rating-container dashboard">
                        <div className="edit-team-feedback-rating-icon">
                            <img src={individual} alt="Individual improvement"/>
                        </div>
                        <div className="edit-team-feedback-rating-main">
                            <div className="edit-team-feedback-rating-title regular grey">
                                <span className="bold">TEAM</span> COMMUNICATION & EFFECTIVENESS
                                <img src={info} alt="Info"
                                     onMouseOver={() => setShowTeamEffectivenessHover(true)}
                                     onMouseLeave={() => setShowTeamEffectivenessHover(false)}
                                />
                            </div>
                            {showTeamEffectivenessHover ?
                                <div className="dashboard-roi-title-hover" style={{top: 29, left: 303}}>
                                    <div className="dashboard-roi-title-hover-triangle-outer">
                                        <div className="dashboard-roi-title-hover-triangle-inner"/>
                                    </div>
                                    <div className="dashboard-roi-title-hover-text regular">
                                        Ratings received for the statement “The Team Coach(es) positively influenced
                                        the communication and effectiveness <span className="underline">of the team as a whole</span>?”
                                    </div>
                                </div> : null
                            }
                            <div className="edit-team-feedback-rating-stars-container">
                                {starMap.map(idx => {
                                    return (
                                        <div className="feedback-rating-star-container" key={idx}>
                                            <div className="feedback-rating-star">
                                                <img src={roiData?.team_improvement >= idx ? filled_star : empty_star}
                                                     alt="Star"/>
                                            </div>
                                            <div className="feedback-rating-number bold">{idx}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="edit-team-feedback-rating-container dashboard">
                        <div className="edit-team-feedback-rating-icon">
                            <img src={team} alt="Individual improvement"/>
                        </div>
                        <div className="edit-team-feedback-rating-main">
                            <div className="edit-team-feedback-rating-title regular grey">
                                <span className="bold">INDIVIDUAL</span> COMMUNICATION & EFFECTIVENESS
                                <img src={info} alt="Info"
                                     onMouseOver={() => setShowIndividualHover(true)}
                                     onMouseLeave={() => setShowIndividualHover(false)}
                                />
                            </div>
                            {showIndividualHover ?
                                <div className="dashboard-roi-title-hover" style={{top: 29, left: 344}}>
                                    <div className="dashboard-roi-title-hover-triangle-outer">
                                        <div className="dashboard-roi-title-hover-triangle-inner"/>
                                    </div>
                                    <div className="dashboard-roi-title-hover-text regular">
                                        Ratings received for the statement “The Team Coach(es) positively influenced
                                        the communication and effectiveness <span className="underline">of you personally within this team</span>?”
                                    </div>
                                </div> : null
                            }
                            <div className="edit-team-feedback-rating-stars-container">
                                {starMap.map(idx => {
                                    return (
                                        <div className="feedback-rating-star-container" key={idx}>
                                            <div className="feedback-rating-star">
                                                <img src={roiData?.individual_improvement >= idx ? filled_star : empty_star}
                                                    alt="Star"/>
                                            </div>
                                            <div className="feedback-rating-number bold">{idx}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="edit-team-feedback-rating-container dashboard">
                        <div className="edit-team-feedback-rating-icon">
                            <img src={recommended} alt="Individual improvement"/>
                        </div>
                        <div className="edit-team-feedback-rating-main">
                            <div className="edit-team-feedback-rating-title regular grey">
                                <span className="bold">OVERALL</span> TEAM COACH RECOMMENDATION
                                <img src={info} alt="Info"
                                     onMouseOver={() => setShowRecommendedHover(true)}
                                     onMouseLeave={() => setShowRecommendedHover(false)}
                                />
                            </div>
                            {showRecommendedHover ?
                                <div className="dashboard-roi-title-hover" style={{top: 29, left: 308}}>
                                    <div className="dashboard-roi-title-hover-triangle-outer">
                                        <div className="dashboard-roi-title-hover-triangle-inner"/>
                                    </div>
                                    <div className="dashboard-roi-title-hover-text regular">
                                        Ratings received for the statement “I would recommend the Team Coach(es) to
                                        another team?”
                                    </div>
                                </div> : null
                            }
                            <div className="edit-team-feedback-rating-stars-container">
                                {starMap.map(idx => {
                                    return (
                                        <div className="feedback-rating-star-container" key={idx}>
                                            <div className="feedback-rating-star">
                                                <img src={roiData?.recommended >= idx ? filled_star : empty_star}
                                                     alt="Star"/>
                                            </div>
                                            <div className="feedback-rating-number bold">{idx}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-roi-title bold margined">
                        Platform Recommendation
                        <img src={info} alt="Info"
                             onMouseOver={() => setShowPlatformHover(true)}
                             onMouseLeave={() => setShowPlatformHover(false)}
                        />
                    </div>
                    {showPlatformHover ?
                        <div className="dashboard-roi-title-hover" style={{top: 460, left: 237}}>
                            <div className="dashboard-roi-title-hover-triangle-outer">
                                <div className="dashboard-roi-title-hover-triangle-inner"/>
                            </div>
                            <div className="dashboard-roi-title-hover-text regular">
                                The below score is the collated ratings score given by all your responding team
                                participants to the following statement: “I would recommend PERILL Diagnostics for
                                Teams to another team”.
                            </div>
                        </div> : null
                    }
                    <div className="edit-team-feedback-rating-container dashboard platform">
                        <div className="edit-team-feedback-rating-main">
                            <div className="edit-team-feedback-rating-stars-container">
                                {starMap.map(idx => {
                                    return (
                                        <div className="feedback-rating-star-container" key={idx}>
                                            <div className="feedback-rating-star">
                                                <img src={roiData?.platform_recommended >= idx ? filled_star : empty_star}
                                                     alt="Star"/>
                                            </div>
                                            <div className="feedback-rating-number bold">{idx}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dashboard-roi-main-right">
                    <div className="dashboard-roi-right-title-container">
                        <div className="dashboard-roi-title bold">
                            Performance Over Time
                            <img src={info} alt="Info"
                                 onMouseOver={() => setShowPerformanceHover(true)}
                                 onMouseLeave={() => setShowPerformanceHover(false)}
                            />
                        </div>
                        {showPerformanceHover ?
                            <div className="dashboard-roi-title-hover" style={{top: 40, left: 210}}>
                                <div className="dashboard-roi-title-hover-triangle-outer">
                                    <div className="dashboard-roi-title-hover-triangle-inner"/>
                                </div>
                                <div className="dashboard-roi-title-hover-text regular">
                                    This table shows your combined aggregated PERILL scores (and function level) for
                                    your teams* over time – including the overall percentage change. You can also
                                    toggle on the benchmarking data to compare your teams performance metrics with
                                    other teams across the platform.
                                    <br/><br/>
                                    *at least two initial and end point responses per team are required to qualify.
                                </div>
                            </div> : null
                        }
                        <div className="dashboard-roi-slider-container">
                            <Slider state={showBenchmark} update={setShowBenchmark.bind(this)}/>
                            <div className="dashboard-roi-slider-text medium">Add benchmarking data</div>
                        </div>
                    </div>
                    <div className="dashboard-roi-chart-container">
                        <div className="dashboard-roi-thermometer-heading regular">START OF COACHING ENGAGEMENT</div>
                        <div className="dashboard-roi-thermometer-container">
                            <div className="dashboard-roi-thermometer-score-circle bold"
                                 style={{left: `${(roiData?.initial_score / 50) * 100}%`}}>
                                {roiData?.initial_score}
                            </div>
                            {showBenchmark ?
                                <div className="dashboard-roi-thermometer-score-circle benchmark bold"
                                     style={{ left: `${(roiData?.benchmark_initial / 50) * 100}%` }}>
                                    {roiData?.benchmark_initial}
                                </div> : null
                            }
                            <div className="dashboard-roi-thermometer-outer-band">
                                <div className="dashboard-roi-thermometer-inner-band">
                                    <div className="dashboard-roi-thermometer-section bold low">LOW</div>
                                    <div className="dashboard-roi-thermometer-section bold med">MEDIUM</div>
                                    <div className="dashboard-roi-thermometer-section bold high">HIGH</div>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-roi-thermometer-markings-container bold">
                            <div className="dashboard-roi-thermometer-marking">0</div>
                            <div className="dashboard-roi-thermometer-marking">50</div>
                        </div>
                        <div className="dashboard-roi-vs bold">VS</div>
                        <div className="dashboard-roi-thermometer-heading regular top-margin">END OF COACHING ENGAGEMENT</div>
                        <div className="dashboard-roi-thermometer-container">
                            <div className="dashboard-roi-thermometer-score-circle bold"
                                 style={{ left: `${(roiData?.endpoint_score / 50) * 100}%` }}>
                                {roiData?.endpoint_score}
                            </div>
                            {showBenchmark ?
                                <div className="dashboard-roi-thermometer-score-circle benchmark bold"
                                     style={{ left: `${(roiData?.benchmark_end / 50) * 100}%` }}>
                                    {roiData?.benchmark_end}
                                </div>
                                : null
                            }
                            <div className="dashboard-roi-thermometer-outer-band">
                                <div className="dashboard-roi-thermometer-inner-band">
                                    <div className="dashboard-roi-thermometer-section bold low">LOW</div>
                                    <div className="dashboard-roi-thermometer-section bold med">MEDIUM</div>
                                    <div className="dashboard-roi-thermometer-section bold high">HIGH</div>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-roi-thermometer-markings-container bold">
                            <div className="dashboard-roi-thermometer-marking">0</div>
                            <div className="dashboard-roi-thermometer-marking">50</div>
                        </div>
                        <div className="dashboard-roi-performance-change-container">
                            <div className="dashboard-roi-performance-container">
                                <div className="dashboard-roi-performance-title regular">PERFORMANCE % CHANGE</div>
                                <div className="dashboard-roi-performance-value-container bold">
                                    {roiData && (roiData.coach_improvement === -100 ?
                                            (<>N/A</>)
                                            : (
                                                <>
                                                    {roiData.coach_improvement}
                                                    <span>%</span>
                                                    <img src={tick} alt="Improvement" className="dashboard-roi-performance-tick"/>
                                                </>
                                            )
                                    )}
                                </div>
                            </div>
                            {showBenchmark ? <div className="dashboard-roi-performance-divider"/> : null}
                            {showBenchmark ?
                                <div className="dashboard-roi-performance-container">
                                    <div className="dashboard-roi-performance-title regular">BENCHMARK % CHANGE</div>
                                    <div className="dashboard-roi-performance-value-container benchmark bold">
                                        {roiData?.benchmark_improvement}<span>%</span>
                                    </div>
                                </div> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ROICard